module.exports = __webpack_public_path__ + "img/30.9b452622.jpg";